var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHandshakeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 81.5 49.9",
    style: {
      enableBackground: "new 0 0 81.5 49.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -13.2,
    y: -29,
    width: 108,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Handshake_3",
    style: {
      clipPath: "url(#clip2)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    transform: "translate(-276 -828)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    style: {
      fill: "#FFFFFF"
    },
    d: "M306.1,871.1c5.2-2.9,9.2-7.2,12.7-11.9l-0.4-0.5c-0.6,0.6-1.2,1.2-1.8,1.7 c-2.8,2.4-5.6,5-8.6,7.2c-1.7,1.1-3.6,1.8-5.6,2.2c-1.4,0.5-3-0.3-3.5-1.7c-0.5-1.6-0.1-2.6,1.4-3.9c3.4-2.8,6.8-5.7,10.1-8.6 c0.8-0.8,1.5-1.7,2-2.7c-1.2,0.1-1.9,1.1-2.8,1.7c-4.2,3.1-8.5,6.2-12.7,9.2c-0.8,0.6-1.7,1-2.7,1.3c-1.5,0.4-3.1-0.3-4-1.6 c-0.9-1.3-0.4-2.5,0.5-3.6c0.9-1.1,1.9-2.1,3-3c7.1-6,14.2-11.9,21.6-18.1c1.2,0.7,2.5,1.6,3.9,2.4c2.2,1.3,4.4,2.5,6.7,3.5 c2.4,1,5.2,0.6,7.1-1.2c1.6-1.3,1.9-2.5,0.7-4.2c-1.6-2.1-3.3-4.1-5.1-5.9c-1.3-1.2-2.5-2.5-3.6-3.9c1.3,0.1,2.7,0.1,4,0.3 c3.7,0.3,7.4,0.6,11.2,0.9c3.9,0.4,7.8-0.3,11.2-2c2.7,7.5,4.7,15.3,6,23.1c-1.8,0-3.3-0.1-4.8,0c-1.8,0.1-3.6,0.3-5.4,0.7 c-2.5,0.5-4.7,2-6,4.2c-4.6-2.1-7.3-2.2-9.1,4c-1.9,0.1-4.2-0.7-5.7,1.5c-1.3,1.9-0.2,3.9-0.1,5.8c-4.6,2.3-4.6,2.3-4.9,8 c-1,0.5-2.1,0.9-3.2,1.3c-1.2,0.4-2.5-0.2-3.1-1.3c-0.6-1.1-0.2-2,0.6-3c2.1-2.2,4-4.5,6-6.8c0.7-0.9,1.2-2,1.4-3.1 c-0.5,0.4-0.9,0.8-1.4,1.2c-2.2,2.1-4.3,4.3-6.4,6.4c-1.5,1.5-3.4,2.5-5.5,2.9C308.1,873.9,307.1,873.3,306.1,871.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    style: {
      fill: "#FFFFFF"
    },
    d: "M287.3,862.7c-4.1,0.3-7.7-1.2-11.3-2.2c0.1-2.5,7.8-22.6,9.9-25.6c1.2,0.5,2.3,1.2,3.5,1.6 c1.6,0.7,3.2,1.3,4.8,1.8c3.4,1.1,7.1,0,9.4-2.6c1.1-1.3,2.4-2.5,3.7-3.5c1.5-1.2,3.1-2.2,4.8-3.1c2.4-1.5,5.4-1.4,7.7,0.2 c3.9,2.4,7.4,5.3,10.3,8.8c0.9,1,2,2.2,1,3.8c-0.7,1.2-2.4,1.6-4.4,0.7c-2.3-1.2-4.6-2.4-6.8-3.8c-4.6-2.8-4.7-2.9-8.9,0.6 c-5.9,4.9-11.7,9.9-17.5,14.9C290.7,856.4,288.5,859.3,287.3,862.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    style: {
      fill: "#FFFFFF"
    },
    d: "M337,868.8c-0.1,2.9-3,4.7-5.2,3.3c-1.5-1-2.7-2.4-3.5-3.9c-0.9-1.7-0.4-3.7,1.2-4.8 c1.5-1,3-0.8,4.6,0.8C335.4,865.6,336.8,867,337,868.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    style: {
      fill: "#FFFFFF"
    },
    d: "M338.8,857.8c0.7,0.4,1.4,0.8,1.9,1.4c0.9,1.3,1.6,2.8,2.2,4.3c0.6,1.4,0,3.1-1.4,3.7 c0,0-0.1,0-0.1,0c-1.2,0.8-2.9,0.5-3.7-0.8c0,0,0,0,0,0c-1.1-1.4-2-3-2.6-4.7C334.4,859.7,336.1,857.8,338.8,857.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    style: {
      fill: "#FFFFFF"
    },
    d: "M326.8,877.9c-1.9,0-2.9-0.9-3.2-2.8c-0.3-1.7,0.7-3.8,2.2-4.2c0.5-0.1,1-0.1,1.4,0.1 c0.7,0.3,1.3,0.6,1.8,1.1c1.1,1,2.4,2,1.8,3.8C330.4,877.1,328.7,878,326.8,877.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    style: {
      fill: "#FFFFFF"
    },
    d: "M346.4,856c1.1,2.9,0.8,3.8-1.9,5.5C342.7,859.1,343,857.9,346.4,856z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandshakeIcon);
export default __webpack_public_path__ + "static/media/handshake-icon.a818ef9c84aff3e3dbfba2c442f96c9c.svg";
export { ForwardRef as ReactComponent };